module.exports = __webpack_public_path__ + "img/4-5-ziliao.2abad02b.png";